const customers = {
    all: 'All Customers',
    customerModalTitle: 'Customer Details',
    table: {
        name: 'Customer Name',
        email: 'Email',
        phone: 'phone',
        visits: 'Total Visits',
        itemPurchased: 'Items Purchased',
        ave: 'Average spent',

    }
}
export default customers